import { Icon } from 'components/Icon/Icon'
import styles from './FailedForm.module.scss'


export function FailedForm() {
    return (
        <div className={styles['form']}>
            <div>
                <Icon name='pig' />
            </div>
            <h1 className={styles['title']}>
                Nona-Marie tried to commit a deposit to your name, but it failed
            </h1>
            <div>
                <article className={styles['item']}>
                    <span>
                        {`It appears that the deposit transaction failed, so the drizzle didn't go through :(`}
                    </span>
                </article>
                <article className={styles['item']}>
                    <span>
                        We notified the sender, but you can also let them know they should try again.
                    </span>
                </article>
                <article className={styles['item']}>
                    <span>
                        Sorry for the inconvenience
                    </span>
                </article>
            </div>
        </div>
    )
}

